import type { ChildAgeOption } from '../model/types';

import { childAgeText } from './formatTourists';
import { MAX_CHILD_AGE, MIN_CHILD_AGE } from './touristsRooms';

export const CHILD_AGE_OPTIONS: ChildAgeOption[] = Array.from(
  { length: MAX_CHILD_AGE - MIN_CHILD_AGE + 1 },
  (_, i): ChildAgeOption => ({ value: MIN_CHILD_AGE + i, label: childAgeText(MIN_CHILD_AGE + i) }),
);
